import { useProjectContext } from "./projectContext";
import { ResponsesMatrixPage } from "@/features/admin/ResponsesMatrixPage";

/** Staff: the responses matrix inside the project workspace. */
export function ProjectResponsesPage() {
  const { project } = useProjectContext();
  return <ResponsesMatrixPage projectId={project.id} />;
}
